// src/meta-pixel.ts
var META_PIXEL_ID = "1718523419227238";
var META_PIXEL_ID_2 = "1483299410291842";
var META_PIXEL_IDS = [META_PIXEL_ID, META_PIXEL_ID_2];
var META_EVENT_INSCRIPTION = "CompleteRegistration";
var HOTES_META_SITE_PUBLIC = ["donoor.org", "www.donoor.org"];
var HOTES_META_DASHBOARD = ["dashboard.donoor.org"];
var chargementPlanifie = false;
var pixelCharge = false;
var pixelsCourants = [...META_PIXEL_IDS];
function pixelMetaCharge() {
  return pixelCharge;
}
function construireFbc(fbclid, horodatageMs = Date.now()) {
  return `fb.1.${horodatageMs}.${fbclid}`;
}
var DUREE_COOKIES_META_S = 90 * 24 * 3600;
function ecrireCookieMeta(nom, valeur) {
  try {
    const estLocal = /^(localhost|127\.|\[?::1)/.test(window.location.hostname);
    const domaine = estLocal ? "" : "; domain=.donoor.org";
    const secure = window.location.protocol === "https:" ? "; Secure" : "";
    document.cookie = `${nom}=${valeur}; path=/; max-age=${DUREE_COOKIES_META_S}; SameSite=Lax${domaine}${secure}`;
  } catch {
  }
}
function assurerCookiesMeta() {
  if (typeof window === "undefined" || typeof document === "undefined") return {};
  let fbclid = null;
  try {
    fbclid = new URLSearchParams(window.location.search).get("fbclid");
  } catch {
    fbclid = null;
  }
  let fbc = lireCookie("_fbc");
  if (fbclid && !fbc) {
    fbc = construireFbc(fbclid);
    ecrireCookieMeta("_fbc", fbc);
  }
  let fbp = lireCookie("_fbp");
  if (!fbp) {
    const aleatoire = Math.floor(Math.random() * 2147483647);
    fbp = `fb.1.${Date.now()}.${aleatoire}`;
    ecrireCookieMeta("_fbp", fbp);
  }
  return { ...fbp ? { fbp } : {}, ...fbc ? { fbc } : {} };
}
function lireCookie(nom) {
  if (typeof document === "undefined") return void 0;
  try {
    const trouve = document.cookie.match(
      new RegExp(`(?:^|;\\s*)${nom}=([^;]*)`)
    );
    return trouve?.[1] ? decodeURIComponent(trouve[1]) : void 0;
  } catch {
    return void 0;
  }
}
function lireContexteMeta() {
  const fbp = lireCookie("_fbp");
  const fbc = lireCookie("_fbc");
  return { ...fbp ? { fbp } : {}, ...fbc ? { fbc } : {} };
}
function injecterPixel(pixelIds) {
  if (pixelCharge) return;
  const fenetre = window;
  if (!fenetre.fbq) {
    const file = [];
    const fbq = function(...args) {
      const methodeReelle = fbq.callMethod;
      if (methodeReelle) methodeReelle.apply(fbq, args);
      else file.push(args);
    };
    fbq.queue = file;
    fbq.loaded = true;
    fbq.version = "2.0";
    fbq.push = fbq;
    fenetre.fbq = fbq;
    if (!fenetre._fbq) fenetre._fbq = fbq;
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://connect.facebook.net/en_US/fbevents.js";
    const premier = document.getElementsByTagName("script")[0];
    premier?.parentNode?.insertBefore(script, premier);
  }
  for (const id of pixelIds) fenetre.fbq?.("init", id);
  for (const id of pixelIds) fenetre.fbq?.("trackSingle", id, "PageView");
  pixelCharge = true;
}
function planifierChargement(pixelIds) {
  if (chargementPlanifie || pixelCharge) return;
  chargementPlanifie = true;
  const evenements = ["scroll", "click", "touchstart", "keydown"];
  const charger = () => {
    evenements.forEach((e) => window.removeEventListener(e, charger));
    injecterPixel(pixelIds);
  };
  evenements.forEach(
    (e) => window.addEventListener(e, charger, { once: true, passive: true })
  );
  const apresLoad = () => setTimeout(charger, 2500);
  if (document.readyState === "complete") apresLoad();
  else window.addEventListener("load", apresLoad, { once: true });
}
function chargerApresLoad(pixelIds) {
  if (chargementPlanifie || pixelCharge) return;
  chargementPlanifie = true;
  const charger = () => injecterPixel(pixelIds);
  if (document.readyState === "complete") charger();
  else window.addEventListener("load", charger, { once: true });
}
function appliquerConsentementMeta(options) {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  const { pixelIds = [...META_PIXEL_IDS], hotesAutorises, consentementMarketing } = options;
  pixelsCourants = pixelIds;
  if (hotesAutorises?.length && !hotesAutorises.includes(window.location.hostname)) {
    return;
  }
  if (!consentementMarketing) {
    window.fbq?.("consent", "revoke");
    return;
  }
  window.fbq?.("consent", "grant");
  assurerCookiesMeta();
  if (vientDunClicPublicitaire()) chargerApresLoad(pixelIds);
  else planifierChargement(pixelIds);
}
function vientDunClicPublicitaire() {
  try {
    if (new URLSearchParams(window.location.search).has("fbclid")) return true;
  } catch {
  }
  return Boolean(lireCookie("_fbc"));
}
function forcerChargementPixelMeta(pixelIds = pixelsCourants) {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  injecterPixel(pixelIds);
}
function emettreConversionMeta(nom, parametres, eventId, options) {
  if (typeof window === "undefined") return;
  if (!options.consentementMarketing) return;
  if (options.hotesAutorises?.length && !options.hotesAutorises.includes(window.location.hostname)) {
    return;
  }
  const pixelIds = options.pixelIds ?? pixelsCourants;
  forcerChargementPixelMeta(pixelIds);
  suivreEvenementMeta(nom, parametres, eventId, pixelIds);
}
function suivreEvenementMeta(nom, parametres, eventId, pixelIds = pixelsCourants) {
  if (typeof window === "undefined") return;
  const fbq = window.fbq;
  if (typeof fbq !== "function") return;
  for (const id of pixelIds) {
    fbq("trackSingle", id, nom, parametres, { eventID: eventId });
  }
}
function nouvelEventIdMeta() {
  try {
    return crypto.randomUUID();
  } catch {
    return `evt-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
  }
}
function pixelsMetaCourants() {
  return [...pixelsCourants];
}

export { HOTES_META_DASHBOARD, HOTES_META_SITE_PUBLIC, META_EVENT_INSCRIPTION, META_PIXEL_ID, META_PIXEL_IDS, META_PIXEL_ID_2, appliquerConsentementMeta, assurerCookiesMeta, construireFbc, emettreConversionMeta, forcerChargementPixelMeta, lireContexteMeta, nouvelEventIdMeta, pixelMetaCharge, pixelsMetaCourants, suivreEvenementMeta };
//# sourceMappingURL=meta-pixel.js.map
//# sourceMappingURL=meta-pixel.js.map